import React, { useState, useEffect } from "react";
import { Chip } from "@mui/material";

interface CellChipStatusProps {
  /** any value; will be converted to string */
  children: any;
}

const customColors: Record<string, string> = {
  ACTIVE: '#0F284C',
  UNDER_NURTURING: '#0F284C',
  INACTIVE: '#D32F2F',
  ARCHIVED: '#E0E0E0',
  NOT_UNDER_NURTURING: '#E0E0E0',
  NOT_AVAILABLE: '#E0E0E0',
  SUCCESS: '#2E7D32',  // Green color for success
  FAILURE: '#D32F2F',  // Red color for failure
  PENDING: '#ED6C02',  // Orange color for pending
  COMPLETED: '#0F284C',  // Green color for completed
  FAILED: '#D32F2F',  // Red color for failed
  RUNNING: '#1976D2',  // Blue color for running status
};

const formatLabel = (label: string) =>
  label
    .toLowerCase()
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const CellChipStatus: React.FC<CellChipStatusProps> = ({ children }) => {
  const [runningText, setRunningText] = useState("Running");
  
  // convert any input to string
  const rawValue = String(children);
  // if string is empty or just whitespace, use fallback key
  const fallbackKey = 'NOT_AVAILABLE';
  const trimmed = rawValue.trim();
  const key = trimmed ? trimmed.toUpperCase() : fallbackKey;

  const backgroundColor = customColors[key] || customColors.NOT_AVAILABLE;
  const formattedLabel = key === 'RUNNING' ? runningText : formatLabel(key);

  const greyTextStatuses = new Set([
    'ARCHIVED',
    'NOT_UNDER_NURTURING',
    'NOT_AVAILABLE',
  ]);

  // Running text animation with setInterval
  useEffect(() => {
    if (key === 'RUNNING') {
      const runningStates = ["Running", "Running.", "Running..", "Running..."];
      let currentIndex = 0;
      
      const interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % runningStates.length;
        setRunningText(runningStates[currentIndex]);
      }, 500); // Change every 500ms
      
      return () => clearInterval(interval);
    }
  }, [key]);

  return (
    <Chip
      label={formattedLabel}
      size="small"
      sx={{
        backgroundColor,
        color: greyTextStatuses.has(key) ? '#848183' : '#fff',
        fontWeight: 500,
        ...(key === 'RUNNING' && {
          color: '#fff !important',
          minWidth: '85px',
          width: 'auto',
          justifyContent: 'flex-start',
          '& .MuiChip-label': {
            textAlign: 'left',
            justifyContent: 'flex-start',
            paddingLeft: '12px',
            paddingRight: '12px',
          }
        })
      }}
    />
  );
};

export default CellChipStatus;
